import React from "react";
import { styled } from "styled-components";

const StyledLabel = styled.label`
  display: flex;
  cursor: pointer;
  margin: 2px 0;

  > input {
    position: relative;
    padding: initial;
    min-width: auto;
    appearance: none;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid var(--checkbox-border-color);
    background: #fff;
    cursor: pointer;
    top: 4px;

    &:checked {
      background: var(--checkbox-fill-color);
      border-color: var(--checkbox-fill-color);
    }

    &:checked::after {
      content: "";
      position: absolute;
      left: 5px;
      top: 1px;
      width: 5px;
      height: 10px;
      border: solid var(--checkbox-check-color);
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`;

const StyledLabelWrapper = styled.div`
  margin-left: ${(props) => props.theme.spacing.xs};

  p {
    margin: 0;
  }

  > * {
    display: inline-block;
  }
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode;
  hasRichLabel?: boolean;
}

export const CheckBox = React.forwardRef<HTMLInputElement, Props>(({
  label,
  hasRichLabel = false,
  ...htmlProps
}, ref) => {
  return (
    <StyledLabel>
      <input ref={ref} type="checkbox" {...htmlProps} />
      <StyledLabelWrapper className="b1">
        {htmlProps.required && !hasRichLabel && (
          <span className="required">*&nbsp;</span>
        )}
        {label}
      </StyledLabelWrapper>
    </StyledLabel>
  );
});
